// Callers pass the bare name, not the display label: "Trevor Beers (Virtual)"
// should still initialise to TB.
export const getInitials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
